import { render, staticRenderFns } from "./DetailsDasboardError.vue?vue&type=template&id=3148c557&scoped=true"
import script from "./DetailsDasboardError.vue?vue&type=script&lang=js"
export * from "./DetailsDasboardError.vue?vue&type=script&lang=js"
import style0 from "./DetailsDasboardError.vue?vue&type=style&index=0&id=3148c557&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148c557",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3148c557')) {
      api.createRecord('3148c557', component.options)
    } else {
      api.reload('3148c557', component.options)
    }
    module.hot.accept("./DetailsDasboardError.vue?vue&type=template&id=3148c557&scoped=true", function () {
      api.rerender('3148c557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Painel/components/DetailsDasboardError.vue"
export default component.exports